import { filter, find } from "lodash/fp";

import useCalendars from "@app/analytics/hooks/calendar/useCalendars";
import useConnectedProviders from "@app/analytics/hooks/sso/useConnectedProviders";
import { CALENDAR_PROVIDERS_BY_ID } from "@app/common/constants/providers";
import { DEFAULT_RSS_LINK_SETTINGS } from "@app/common/constants/rssLinks";
import { getSchedulingLinkUrl } from "@app/common/utils";

import useUserSettings from "./useUserSettings";

const useRssLinksSettings = () => {
  const { userSettings, updateRssLinkSettings, updateRssLinkSettingsSync } =
    useUserSettings();

  const { connectedCalendarProviders } = useConnectedProviders();
  const { calendars, calendarsForProvider } = useCalendars();

  const rssCalendarId = userSettings.rssLinkSettings?.calendarId;
  const rssCalendar = find({ id: rssCalendarId }, calendars);

  // a calendar provider is only considered "connected" for RSS if it has >0 enabled calendars
  const connectedRssCalendarProviders = filter(
    ({ providerId }) =>
      CALENDAR_PROVIDERS_BY_ID[providerId].supportsRssLinks &&
      filter({ isEnabled: true }, calendarsForProvider(providerId)).length > 0,
    connectedCalendarProviders
  );

  return {
    connectedRssCalendarProviders,
    hasConnectedRssCalendarProviders: connectedRssCalendarProviders.length > 0,
    rssCalendar,
    rssLinkSettings: userSettings.rssLinkSettings ?? DEFAULT_RSS_LINK_SETTINGS,
    updateRssLinkSettings,
    updateRssLinkSettingsSync,
    rootSchedulingLinkUrl: getSchedulingLinkUrl(
      userSettings.rssLinkSettings?.vanityId ?? ""
    ),
  };
};

export default useRssLinksSettings;
